/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { VerticalCenterGrid } from '../components/Grid';
import PreformattedText from '../components/PreformattedText';

const ContentError = (props) => (
  <div className="cmp-contenterror">

    <div className="cmp-contenterror-content util-application-frame-forcards-padding">
      <VerticalCenterGrid>

        {props.mainImage}

        <div className="cmp-contenterror-explanation">
          <PreformattedText text={props.explanation} textValues={props.textValues} textClassName={props.textClassName} />
        </div>

        {props.children}
      </VerticalCenterGrid>
    </div>
  </div>
);
ContentError.propTypes = {
  mainImage: PropTypes.object,
  explanation: PropTypes.string,
  children: PropTypes.element,
  textValues: PropTypes.object,
  textClassName: PropTypes.string,
};

export default ContentError;
